import { chain } from 'lodash';
import { useSelector } from 'react-redux';

import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import {
  useGetCounselorClassesQuery,
  useGetMBCDashboardQuery,
} from '@modules/meritBadgeCounselors/api';
import { currentUserMIDSel } from '@user/duck/selectorsTyped';

import { searchSel } from './selectors';
import { YouthByMBRowKey } from './utils';

/** This is meant to be used as the user logged in as MBC */
export function useSelfMBCDashboard() {
  const memberId = useSelector(currentUserMIDSel);
  const dashboard = useGetMBCDashboardQuery(
    { personGuidOrMID: memberId },
    { skip: !memberId },
  );
  return { dashboard };
}

export function useYouthGroupedByClass() {
  const searchTerm = useSelector(searchSel);
  const memberId = useSelector(currentUserMIDSel);

  const { data: mbcClasses } = useGetCounselorClassesQuery(
    {
      params: { counselorMemberId: memberId },
    },
    {
      skip: !featureFlags.getFlag('SBL_6160_ENABLE_MBC_CLASS'),
    },
  );

  const mbClassesDict = chain(mbcClasses ?? [])
    .filter(item => {
      const searchProps = [item.className];
      return searchProps
        .join(' ')
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
    })
    .map(mbcClass => ({
      ...mbcClass,
      scouts: mbcClass.scouts.map(scout => ({
        ...scout,
        rowKey: YouthByMBRowKey.getKey({
          memberId: scout.scoutMemberId,
          meritBadgeId: mbcClass.meritBadgeId,
        }),
      })),
    }))
    .keyBy('counselorClassId')
    .value();

  return { mbClassesDict, mbcClassesArray: mbcClasses ?? [] };
}
